import { Pipe, PipeTransform } from '@angular/core';
import { CatalogTagModel } from 'src/app/views/models/allergen.model';

@Pipe({
  name: 'tagName'
})
export class TagNamePipe implements PipeTransform {

  transform(tag: CatalogTagModel): any {
    try {
      return JSON.parse(tag.name).name;
    } catch (error) {
      return null;
    }
  }

}
